/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useLayoutEffect, useRef } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import OnSubmit from '../ReceiveSubmit/OnSubmit';
import AddSetsLists from './AddSetsLists';
import DesktopSetsList from './DesktopSetsList';
import MobileSetsList from './MobileSetsList';
import Territory from './Territory';
import Account from './Account';
import { DetailsMainContainer, SetsHeader } from './index.styled';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import {
    getDropdownValues,
    setReceiveSetsDetails,
    getValidateAccountDetails,
    deleteAllSets,
    resetBarcodeDetails,
    clearSingleDropDownList,
    TerritorySelected,
    SetNumberSelected,
    BatchNumberSelected,
} from 'src/pages/receiveSets/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import AccountPhysicianTemplate from './AccountPhysicianTemplate';
import {
    EQUITYVALIDATEACCOUNT,
    CREDITCARDPAYMENTMESSAGE,
} from 'src/constants/productConstants';
import { debounce, logErrorToConsole } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
// import SetItemList from './SetSearchTemplate.jsx';

const ReceiveSetsLoc = ({
    isSubmitClicked,
    setIsSubmitClicked,
    setSetFieldFocus,
    counterMessage,
    setCounterMessage,
    territoryValue,
    setTerritoryValue,
    accountValue,
    setAccountValue
}) => {
    const [expandedCard, setExpandedCard] = useState({
        receive_location: true,
        add_set_scan: false,
        add_set_manually: false,
    });

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const [disableFormFields] = useState(false);
    const [physiciantype] = useState('favorites');
    const [listArr, setListArr] = useState([]);
    const [isBulkAdd, setIsBulkAdd] = useState(false);
    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
        template: false,
    });
    const [blockedAccountMessage, setBlockedAccountMessage] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    useLayoutEffect(() => {
        setBlockedAccountMessage(false);
    }, []);
    // useEffectWithErrorLogging(() => {
    //     dispatch(getDropdownValues({ dropDownName: 'territories' }));
    // }, []);
    useEffectWithErrorLogging(() => {
        if (accountValue.length >= 1 && accounts.length === 0) {
            handleDisableField('account', false);
        }
    }, [accounts]);

    const {
        territories,
        territoryId,
        accounts,
        loading,
        accountId,
        validateAccount,
        accountsOptionLoading,
        loadAll,
        physicianLoadAllLoading,
        setsList,
    } = useSelector((state) => ({
        territories: state.receiveSetsDetailsDropdownsReducer.territories.items,
        territoryId: state.receiveSetsReducer.surgeryDetails.territoryId,
        accounts: state.receiveSetsDetailsDropdownsReducer.accounts.items,
        loading: state.receiveSetsDetailsDropdownsReducer.accounts.loading,
        validateAccount: state.validateAccountReducer.validateAccount,
        accountId: state.receiveSetsReducer.surgeryDetails.accountId,
        accountsOptionLoading:
            state.receiveSetsDetailsDropdownsReducer.accounts.loading,
        loadAll: state.receiveSetsDetailsDropdownsReducer.physicianList.loadAll,
        physicianLoadAllLoading:
            state.receiveSetsDetailsDropdownsReducer.physicianList
                .physicianLoadAllLoading,
        setsList: state.receiveSetsListDataReducer.receiveSetsListData,
    }));
    useNonInitialRenderHook(() => {
        if (
            validateAccount.data.blockMessage &&
            blockedAccountMessage === false
        ) {
            setBlockedAccountMessage(true);
        } else {
            setBlockedAccountMessage(false);
        }
    }, [validateAccount]);

    useEffectWithErrorLogging(() => {
        if (accountId === '' || (territoryId && !territoryId?.length)) {
            dispatch(deleteAllSets());
            dispatch(resetBarcodeDetails());
        }
        if (accountId === '' && territoryId === '') {
            dispatch(getDropdownValues({ dropDownName: 'territories' }));
        }
    }, [accountId, territoryId]);
    const setFormValues = (selectedField, fieldname) => {
        if (fieldname === 'district') {
            dispatch(
                getDropdownValues({
                    dropDownName: 'territories',
                    value: selectedField['districtId'],
                })
            );
        }
        //calling account related to districtId and territoryId;Saleem
        // if (selectedField?.territoryId) {
        //     dispatch(
        //         getDropdownValues({
        //             dropDownName: 'accounts',
        //             districtId: 'ALL_DISTRICTS',
        //             territoryId: selectedField.territoryId,
        //         })
        //     );
        // }
        dispatch(setReceiveSetsDetails(selectedField));
    };
    const handleClosePopup = () => {
        setAccountValue('');
        setBlockedAccountMessage(false);
        dispatch(
            setReceiveSetsDetails({
                accountId: '',
            })
        );
    };
    const onTerritoryChange = (value) => {
        const obj = {
            territoryId: value,
        };
        if (value === '') {
            obj['accountId'] = '';
            dispatch(SetNumberSelected(''));
            dispatch(BatchNumberSelected(''));
        }
        setFormValues(obj);
        // setFormValues({
        //     accountId: ''
        // });
        // dispatch(
        //     clearSingleDropDownList({
        //         name: 'accounts',
        //     })
        // );
        // dispatch(
        //     getDropdownValues({
        //         dropDownName: 'accounts',
        //         districtId: selectedField['districtId'],
        //         templateId: template?.templateUID,
        //     })
        // );
    };
    const AccountTemplate = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                data={fieldname == 'account' ? accounts : physicians}
                optionValue={
                    fieldname == 'account' ? 'accountId' : 'physicianId'
                }
                fieldname={fieldname}
                onLoadMore={() => handleLoadAll(true)}
                showLoadMore={!loadAll}
                showOptionLoader={physicianLoadAllLoading}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };
    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;
    const handleSearch = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                // searchValue: value?.trim() || '',
                searchValue: value?.trim() || '',
            };
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                debouncedGetList(getPhysicanList, option);
            } else if (fieldname == 'account') {
                setAccountValue(value);
                debouncedGetList(getAccountList, option);
            } else if (fieldname == 'template') {
                // setTemplateValue(value);
                // getTemplateList(option);
            }
        } else {
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                handleInputChange(
                    'physicianDropDown',
                    physiciantype === 'favorites' ? 'Favorites' : 'All'
                );
            } else if (fieldname == 'template') {
                // setCallTemplates(false);
                // setTemplateValue(value);
            } else {
                setAccountValue(value);
                handleDisableField('account', false);
                if(fieldname==='account' && value===''){
                    setTerritoryValue('');
                }
            }
        }
    };
    const handleOnfocus = (event, field) => {
        if (field == 'accounts') {
            getAccountList({
                searchValue: event?.target?.value?.trim() || '',
            });
            // dispatch(clearAccountId());
        } else if (field === 'templates' && !callTemplates) {
            setCallTemplates(true);
            dispatch(
                getDropdownValues({
                    dropDownName: 'templates',
                })
            );
        } else if (field === 'physicians') {
            setCallTemplates(true);
            dispatch(
                getDropdownValues({
                    dropDownName: 'physicians',
                    salesOrg: salesOrg,
                    countryISOCode: countryISOCode,
                })
            );
        }
    };
    const handleInputChange = (name, value) => {
        const object = {
            [name]: value,
        };
        if (
            name == 'accountId' &&
            value != '' &&
            value.errorMessage == undefined
        ) {
            EQUITYVALIDATEACCOUNT.sapPartnerId = value.accountId;
            dispatch(getValidateAccountDetails(EQUITYVALIDATEACCOUNT));
        }
        // else if (name == 'accountId' && value === '') {
        //     handleInputChange('caseCoverageId', '');
        // }
        if (name === 'accountId' && value === '') {
            object['territoryId'] = '';
            dispatch(
                clearSingleDropDownList({
                    name: 'territories',
                })
            );
            dispatch(TerritorySelected(''));
            dispatch(
                setReceiveSetsDetails({
                    territoryId: '',
                })
            );
        }
        if (name == 'accountId' && value.errorMessage) {
            setModalErrorMessage(value.errorMessage);
        }
        // else if (name == 'template') {
        //     dispatch(
        //         setCartData({
        //             products: [],
        //         })
        //     );
        //     return;
        // }
        else {
            dispatch(setReceiveSetsDetails(object));
        }
    };
    const handleDisableField = (fieldName, value) => {
        setDisableFields({
            ...disableFields,
            [fieldName]: value,
        });
    };
    const getAccountList = (data, districtIdFromEdit, territoryIdFromEdit) => {
        const { searchValue } = data;
        let params = {
            //district: districtId ? districtId : districtIdFromEdit,
            territory: territoryId ? territoryId : territoryIdFromEdit,
            searchParam: searchValue ? searchValue : '',
            //templateId: template?.templateUID,
        };
        dispatch(
            getDropdownValues({ dropDownName: 'accounts', value: params })
        );
    };
    const getAccountOnBlur = () => {
        dispatch(
            getDropdownValues({
                dropDownName: 'accounts',
                value: { territory: territoryId ? territoryId : '' },
            })
        );
    };
    const closekeyBoard = () => {
        document.activeElement.blur();
    };
    return (
        <>
            {!isSubmitClicked ? (
                <>
                    {blockedAccountMessage ? (
                        <MessageTemplate
                         id="receivesets-receivesetsloc-messagetemplate-accountblocked"
                            isDeliveryCheck={true}
                            onClose={() => {
                                try {
                                handleClosePopup();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            content={validateAccount.data.blockMessage}
                            width={'100%'}
                            marginB={'32px'}
                            position={'static'}
                            title={t(
                                'ConsignmentAdd.surgery.notifications.accountBlocked'
                            )}
                            fontWeight={'800'}
                            height={'auto'}
                        />
                    ) : null}
                    <CollapsableCard id="receiveSets-receiveSetsLoc-receiveSetsLoc-receiveToLocation"
                        title={t(
                            'receiveSets.ReceiveSetsLoc.AddSetsLists.ReceiveToLocation'
                        )}
                        onClick={() =>
                            toggleCard(
                                'receive_location',
                                !expandedCard.receive_location
                            )
                        }
                        isExpanded={expandedCard.receive_location}
                        currentActivity
                        titleFontSize={'18px'}
                        fontSizeMobile={'16px'}
                    >
                        {expandedCard.receive_location ? (
                            <DetailsMainContainer>
                                <Territory
                                    territories={territories}
                                    territoryId={territoryId}
                                    onTerritoryChange={onTerritoryChange}
                                    setAccountValue={setAccountValue}
                                    territoryValue={territoryValue}
                                    setTerritoryValue={setTerritoryValue}
                                />
                                <Account
                                    accountId={accountId} 
                                    AccountTemplate={AccountTemplate}
                                    accountValue={accountValue}
                                    accounts={accounts}
                                    loading={loading}
                                    handleOnfocus={handleOnfocus}
                                    handleInputChange={handleInputChange}
                                    handleSearch={handleSearch}
                                    isCreditCardAccount={validateAccount}
                                    isFormFieldsDisabled={disableFormFields}
                                    handleDisableField={handleDisableField}
                                    isAccountsOptionLoading={
                                        accountsOptionLoading
                                    }
                                    getAccountOnBlur={getAccountOnBlur}
                                    territoryId={territoryId}
                                    closekeyBoard={closekeyBoard}
                                    creditCardMessage={CREDITCARDPAYMENTMESSAGE()}
                                    isFieldsDisabled={disableFields.account}
                                    setTerritoryValue={setTerritoryValue}
                                />
                            </DetailsMainContainer>
                        ) : null}
                    </CollapsableCard>
                    {accountId &&
                        accountId.accountName.length > 0 &&
                        territoryId &&
                        territoryId.length > 0 && (
                            <AddSetsLists
                                territoryId={territoryId}
                                accountId={accountId}
                                setListArr={setListArr}
                                listArr={listArr}
                                setSetFieldFocus={setSetFieldFocus}
                                counterMessage={counterMessage}
                                setCounterMessage={setCounterMessage}
                                setIsBulkAdd={setIsBulkAdd}
                            />
                        )}
                    {setsList &&
                        setsList.length > 0 &&
                        accountId &&
                        accountId.accountName.length > 0 &&
                        territoryId &&
                        territoryId.length > 0 && (
                            <>
                                <SetsHeader>
                                    {t(
                                        'receiveSets.ReceiveSetsLoc.DesktopSetsList.sets'
                                    )}{' '}
                                    ({setsList.length})
                                </SetsHeader>
                                <DesktopSetsList
                                    setsList={setsList}
                                    setListArr={setListArr}
                                    listArr={listArr}
                                    isBulkAdd={isBulkAdd}
                                    counterMessage={counterMessage}
                                    setCounterMessage={setCounterMessage}
                                />
                                <MobileSetsList
                                    setsList={setsList}
                                    setListArr={setListArr}
                                    listArr={listArr}
                                    counterMessage={counterMessage}
                                    setCounterMessage={setCounterMessage}
                                />
                            </>
                        )}
                </>
            ) : (
                <OnSubmit
                    setIsSubmitClicked={setIsSubmitClicked}
                    counterMessage={counterMessage}
                    setCounterMessage={setCounterMessage}
                />
            )}
        </>
    );
};

export default ReceiveSetsLoc;
